import type { ReminderSettingsRepository } from '../repositories/reminder-settings-repository';

export class DeleteReminderSettingsUseCase {
  constructor(private readonly repository: ReminderSettingsRepository) {}

  async execute(userId: string, id: string): Promise<void> {
    return this.repository.delete(userId, id);
  }
}
